import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout eyebrow="Legal" title="Terms of Service" lastUpdated="December 2026">
      <p>
        These terms govern your use of the Mackbe Tech Ltd website. By accessing
        or using this site, you agree to these terms. If you do not agree, please
        do not use the site.
      </p>

      <h2>1. About us</h2>
      <p>
        Mackbe Tech Ltd is a company registered in England with its registered
        office at 400 Thames Valley Park Dr, Earley, Reading, RG6 1PT, United
        Kingdom.
      </p>

      <h2>2. Use of the site</h2>
      <p>
        You may access this site for personal and business research purposes. You
        agree not to misuse the site, attempt to gain unauthorised access, or
        introduce harmful code.
      </p>

      <h2>3. Intellectual property</h2>
      <p>
        All content on this site — including text, design, logos, graphics and
        code — is the property of Mackbe Tech Ltd or its licensors, and is
        protected by UK and international intellectual property laws. You may not
        copy, reproduce, or republish any content without prior written consent.
      </p>

      <h2>4. Project work and engagements</h2>
      <p>
        Any project, consulting, design or development work delivered by Mackbe
        Tech Ltd is governed by a separate written agreement (proposal, statement
        of work, or contract). Nothing on this website constitutes a binding
        offer or contract for services.
      </p>

      <h2>5. Disclaimer</h2>
      <p>
        The site is provided on an "as is" basis. We make no warranties about
        accuracy, completeness or availability. To the extent permitted by law,
        we exclude liability for any loss arising from use of this site.
      </p>

      <h2>6. Third-party links</h2>
      <p>
        This site may contain links to third-party websites. We are not
        responsible for the content, privacy practices or availability of those
        sites.
      </p>

      <h2>7. Governing law</h2>
      <p>
        These terms are governed by the laws of England and Wales. Any dispute
        will be subject to the exclusive jurisdiction of the English courts.
      </p>

      <h2>8. Contact</h2>
      <p>
        Questions about these terms: <a href="mailto:hello@mackbetech.com">hello@mackbetech.com</a>.
      </p>
    </LegalLayout>
  );
}
